import React, { useState, useEffect } from "react";
import {
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  Box,
  Switch,
  FormControlLabel,
} from "@material-ui/core";
import { toast } from "react-toastify";

const EMOJIS = ["✅", "👍", "❤️", "😂", "😮", "🤔", "🙏", "👏", "🔥", "💯", "🤝", "🎉"];


// O motor trabalha em minutos; aqui o usuario escolhe a unidade e a gente converte.
const EM_MINUTOS = { segundos: 1 / 60, minutos: 1, horas: 60, dias: 1440 };
const LIMITE_MINUTOS = 31 * 24 * 60; // 31 dias
const maximoNaUnidade = (u) => Math.floor(LIMITE_MINUTOS / (EM_MINUTOS[u] || 1));

const FlowBuilderWaitResponseModal = ({ open, onSave, onUpdate, data, close }) => {
  const [activeModal, setActiveModal] = useState(false);

  const [message, setMessage] = useState("");
  const [answerKey, setAnswerKey] = useState("resposta");
  const [waitForever, setWaitForever] = useState(true);
  const [noAnswerMinutes, setNoAnswerMinutes] = useState("");
  const [noAnswerUnit, setNoAnswerUnit] = useState("minutos");
  const [bufferEnabled, setBufferEnabled] = useState(false);
  const [bufferSeconds, setBufferSeconds] = useState("30");
  const [quoteEnabled, setQuoteEnabled] = useState(false);
  const [reactEnabled, setReactEnabled] = useState(false);
  const [reactEmoji, setReactEmoji] = useState("✅");

  useEffect(() => {
    if (open === "edit") {
      const d = data?.data || data || {};
      setMessage(d.message || "");
      setAnswerKey(d.answerKey || "resposta");
      const mins = Number(d.noAnswerMinutes) || 0;
      setWaitForever(!mins);
      // Mostra o numero como o usuario digitou (ex.: "1" + Dias), nao os
      // minutos convertidos que ficam salvos para o motor.
      const unidadeSalva = d.noAnswerUnit || "minutos";
      const digitado =
        d.noAnswerValue !== undefined &&
        d.noAnswerValue !== null &&
        String(d.noAnswerValue) !== ""
          ? String(d.noAnswerValue)
          : mins
          ? String(
              Math.round((mins / (EM_MINUTOS[unidadeSalva] || 1)) * 100) / 100
            )
          : "";
      setNoAnswerMinutes(digitado);
      setNoAnswerUnit(unidadeSalva);
      setBufferEnabled(!!d.bufferEnabled);
      setBufferSeconds(String(d.bufferSeconds || 30));
      setQuoteEnabled(!!d.quoteEnabled);
      setReactEnabled(!!d.reactEnabled);
      setReactEmoji(d.reactEmoji || "✅");
      setActiveModal(true);
    } else if (open === "create") {
      setMessage("");
      setAnswerKey("resposta");
      setWaitForever(true);
      setNoAnswerMinutes("");
      setBufferEnabled(false);
      setBufferSeconds("30");
      setQuoteEnabled(false);
      setReactEnabled(false);
      setReactEmoji("✅");
      setActiveModal(true);
    }
  }, [open, data]);

  const handleClose = () => {
    close(null);
    setActiveModal(false);
  };

  const handleSave = () => {
    const mins = waitForever ? 0 : Number(noAnswerMinutes) || 0;
    if (!waitForever && mins <= 0) {
      toast.error("Informe em quantos minutos seguir sem resposta.");
      return;
    }
    const secs = bufferEnabled ? Number(bufferSeconds) || 0 : 0;
    if (bufferEnabled && secs <= 0) {
      toast.error("Informe os segundos do buffer.");
      return;
    }
    const payload = {
      message,
      answerKey: (answerKey || "resposta").trim(),
      noAnswerMinutes: mins
        ? Math.min(
            LIMITE_MINUTOS,
            Math.round(Number(mins) * (EM_MINUTOS[noAnswerUnit] || 1) * 100) / 100
          )
        : mins,
      noAnswerValue: mins,
      noAnswerUnit,
      bufferEnabled,
      bufferSeconds: secs,
      quoteEnabled,
      reactEnabled,
      reactEmoji,
    };
    if (open === "edit") {
      onUpdate({ ...data, data: { ...(data?.data || {}), ...payload } });
    } else {
      onSave(payload);
    }
    handleClose();
  };

  const box = { background: "#f8fafc", borderRadius: 8, padding: 12, marginBottom: 12 };

  return (
    <Dialog open={activeModal} onClose={handleClose} maxWidth="sm" fullWidth scroll="paper">
      <DialogTitle>
        {open === "create" ? "Adicionar Aguarda Resposta" : "Editar Aguarda Resposta"}
      </DialogTitle>
      <DialogContent dividers>
        <Box style={box}>
          <FormControlLabel
            control={
              <Switch
                checked={waitForever}
                onChange={(e) => setWaitForever(e.target.checked)}
                color="primary"
              />
            }
            label="Aguardar indefinidamente (sem encerrar por tempo)"
          />
          <Typography variant="caption" color="textSecondary" display="block">
            O fluxo só avança quando o cliente responder.
          </Typography>
          {!waitForever && (
            <>
              <Typography
                variant="caption"
                display="block"
                style={{ marginTop: 10, fontWeight: 600 }}
              >
                Tempo máximo aguardando a resposta do cliente
              </Typography>
              <Box style={{ display: "flex", gap: 10, marginTop: 6 }}>
                <TextField
                  type="number"
                  size="small"
                  variant="outlined"
                  value={noAnswerMinutes}
                  onChange={(e) => setNoAnswerMinutes(e.target.value)}
                  inputProps={{ min: 1, max: maximoNaUnidade(noAnswerUnit) }}
                  style={{ width: 150 }}
                />
                <TextField
                  select
                  size="small"
                  variant="outlined"
                  value={noAnswerUnit}
                  onChange={(e) => setNoAnswerUnit(e.target.value)}
                  style={{ width: 150 }}
                >
                  <MenuItem value="segundos">Segundos</MenuItem>
                  <MenuItem value="minutos">Minutos</MenuItem>
                  <MenuItem value="horas">Horas</MenuItem>
                  <MenuItem value="dias">Dias</MenuItem>
                </TextField>
              </Box>
              <Typography
                variant="caption"
                color="textSecondary"
                display="block"
                style={{ marginTop: 6 }}
              >
                Limite total: 31 dias (máximo{" "}
                {maximoNaUnidade(noAnswerUnit).toLocaleString("pt-BR")} nesta
                unidade). Passado o tempo, o fluxo segue pela saída cinza "Não
                respondeu".
              </Typography>
            </>
          )}
        </Box>

        <Box style={box}>
          <FormControlLabel
            control={
              <Switch
                checked={bufferEnabled}
                onChange={(e) => setBufferEnabled(e.target.checked)}
                color="primary"
              />
            }
            label="Agrupar mensagens do cliente (buffer)"
          />
          <Typography variant="caption" color="textSecondary" display="block">
            Espera alguns segundos e junta várias mensagens seguidas em uma só resposta.
          </Typography>
          {bufferEnabled && (
            <TextField
              label="Aguardar (segundos)"
              type="number"
              size="small"
              variant="outlined"
              value={bufferSeconds}
              onChange={(e) => setBufferSeconds(e.target.value)}
              inputProps={{ min: 1, max: 300 }}
              style={{ marginTop: 8, width: 200 }}
            />
          )}
        </Box>

        <Box style={box}>
          <FormControlLabel
            control={
              <Switch
                checked={quoteEnabled}
                onChange={(e) => setQuoteEnabled(e.target.checked)}
                color="primary"
              />
            }
            label="Responder citando a mensagem do cliente"
          />
          <FormControlLabel
            control={
              <Switch
                checked={reactEnabled}
                onChange={(e) => setReactEnabled(e.target.checked)}
                color="primary"
              />
            }
            label="Reagir na mensagem do cliente"
          />
          {reactEnabled && (
            <Box style={{ display: "flex", flexWrap: "wrap", gap: 6, marginTop: 6 }}>
              {EMOJIS.map((e) => (
                <Button
                  key={e}
                  onClick={() => setReactEmoji(e)}
                  variant={reactEmoji === e ? "contained" : "outlined"}
                  color={reactEmoji === e ? "primary" : "default"}
                  style={{ minWidth: 44, fontSize: 18, padding: "4px 0" }}
                >
                  {e}
                </Button>
              ))}
            </Box>
          )}
        </Box>

        <TextField
          label="Salvar resposta em"
          size="small"
          variant="outlined"
          fullWidth
          value={answerKey}
          onChange={(e) => setAnswerKey(e.target.value)}
          helperText="Use depois no fluxo como {{resposta}}"
          style={{ marginBottom: 12 }}
        />

        <TextField
          label="Mensagem antes de aguardar"
          variant="outlined"
          fullWidth
          multiline
          minRows={3}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          helperText="Ex: Poderia escrever apenas SIM ou NÃO?"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancelar</Button>
        <Button onClick={handleSave} color="primary" variant="contained">
          {open === "create" ? "Adicionar" : "Salvar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FlowBuilderWaitResponseModal;
